import React from 'react';
import PropTypes from 'prop-types';
import uiActions from 'tradera-state/ui/actions';
import { VideoButton } from 'components';

const YoutubeVideo = ({
    youtubeVideoId,
    pageName,
    width,
    height,
    dispatch
}) => (
    <div className="position-relative mr-3">
        <div
            className="social-media-slider__youtube__overlay position-absolute"
            onClick={() =>
                dispatch(
                    uiActions.openVideoModal({
                        videoId: youtubeVideoId,
                        title: '',
                        pageType: pageName
                    })
                )
            }
            style={{
                width: `${width}px`,
                height: `${height}px`
            }}>
            <VideoButton
                className="social-media-slider__youtube__button position-absolute mr-2 mt-2 pt-1"
                videoId={youtubeVideoId}
                pageType={pageName}
                title=""
            />
        </div>
        <img
            src={`https://img.youtube.com/vi/${youtubeVideoId}/default.jpg`}
            width={width}
            height={height}
            alt="Youtube thumbnail"
        />
    </div>
);

YoutubeVideo.propTypes = {
    youtubeVideoId: PropTypes.string.isRequired,
    pageName: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default YoutubeVideo;
